import { render, staticRenderFns } from "./PersonalInfoForm.vue?vue&type=template&id=02823e01&"
import script from "./PersonalInfoForm.vue?vue&type=script&lang=ts&"
export * from "./PersonalInfoForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports